import { createFileRoute } from '@tanstack/react-router'
import type { StockCondition, UsedGrade } from '@/api/warehouse'
import { ItemPage } from '@/features/warehouse/item-page'

const CONDITIONS: readonly StockCondition[] = ['new', 'open_box', 'scratch_dent', 'used']
const GRADES: readonly UsedGrade[] = ['like_new', 'good', 'fair']

type ItemSearch = { condition: StockCondition; grade?: UsedGrade }

export const Route = createFileRoute('/_authenticated/warehouse/item/$productId')({
  staticData: { title: 'Warehouse stock' },
  validateSearch: (search: Record<string, unknown>): ItemSearch => ({
    condition: CONDITIONS.find((value) => value === search.condition) ?? 'new',
    grade: GRADES.find((value) => value === search.grade),
  }),
  component: ItemRoute,
})

function ItemRoute() {
  const { productId } = Route.useParams()
  const { condition, grade } = Route.useSearch()
  return <ItemPage productUuid={productId} condition={condition} grade={grade ?? null} />
}
